<div style="padding: 10px !important;  width:100% !important; background-color: white" class="box-padrao-table">
  <h4 style="margin-top: 5px; margin-bottom: 20px; font-size: 20px; font-weight: 500; color: #434a54;">Rastrear Protocolos</h4>
  <mat-accordion>
    <mat-expansion-panel class="expansion-panel" expanded>
      <mat-expansion-panel-header class="custom-header">
        <mat-panel-title>
          <mat-icon>search</mat-icon> Pesquisar protocolos
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-progress-bar *ngIf="loadAcompanhamento" class="progress-bar" mode="indeterminate"></mat-progress-bar>
      <form [formGroup]="pesquisaForm">
        <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
          <mat-form-field fxFlex="20%">
            <input matInput onlyNumbers maxlength="9" (keyup.enter)="pesquisar()" formControlName="frmNProtocolo" [(ngModel)]="filtros.idProtocolo"
              placeholder="N° Protocolo" required>
            <mat-error *ngIf="f.frmNProtocolo.errors && f.frmNProtocolo.errors.required">Campo obrigatório</mat-error>
          </mat-form-field>
        </div>
        <mat-action-row class="footer">
          <button mat-button type="button" [disabled]="desabilitarPesquisar()" color="primary" class="btn-primary"
            (click)="pesquisar()">PESQUISAR</button>
        </mat-action-row>
      </form>
    </mat-expansion-panel>
  </mat-accordion>
  <br />
  <div class="custom-Border" *ngIf="exibirResultado" >
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field class="select-disabled" fxFlex="20%">
        <mat-select placeholder="SISTEMA" [(ngModel)]="cabecalho.origem" disabled>
          <mat-option *ngFor="let item of sistemas" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="select-disabled" fxFlex="30%">
        <mat-select placeholder="STATUS DO PROTOCOLO" [(ngModel)]="cabecalho.statusNovo" disabled>
          <mat-option *ngFor="let item of statusNovoProtocolo" [value]="item.value">
            {{item.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-disabled" fxFlex="35%" *ngIf="protocolo.descricaoStatus !== ''">
        <input matInput readonly [(ngModel)]="cabecalho.statusDescricao" value="{{cabecalho.statusDescricao}}"
          placeholder="DESCRIÇÃO STATUS">
      </mat-form-field>
      <mat-form-field class="input-disabled" fxFlex="35%" *ngIf="protocolo.statusPagamento !== ''">
        <input matInput readonly [(ngModel)]="cabecalho.statusPagamento" value="{{cabecalho.statusPagamento}}"
          placeholder="STATUS PAGAMENTO">
      </mat-form-field>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field fxFlex="25%">
        <input matInput readonly [(ngModel)]="cabecalho.fornecedor" placeholder="FORNECEDOR">
      </mat-form-field>
      <mat-form-field class="input-disabled" fxFlex="20%">
        <input matInput readonly [(ngModel)]="cabecalho.nota" placeholder="Nº DOCUMENTO">
      </mat-form-field>
      <mat-form-field fxFlex="25%">
        <span matPrefix>R$</span>
        <input matInput readonly placeholder="VALOR TOTAL DA NF" [(ngModel)]="cabecalho.valor"
          class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }">
      </mat-form-field>
      <mat-form-field fxFlex="25%">
        <input matInput [(ngModel)]="cabecalho.emissao" [matDatepicker]="picker" placeholder="EMISSÃO" readonly>
        <span matSuffix class="calendar">
          <mat-icon>calendar_today</mat-icon>
        </span>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field fxFlex="25%">
        <input matInput [(ngModel)]="cabecalho.vencimento" [matDatepicker]="picker1" placeholder="VENCIMENTO"
          readonly>
        <span matSuffix class="calendar">
          <mat-icon>calendar_today</mat-icon>
        </span>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-form-field class="input-disabled" fxFlex="20%">
        <input matInput readonly [(ngModel)]="cabecalho.usuarioCriacao" placeholder="USUÁRIO CRIAÇÃO">
      </mat-form-field>
      <mat-form-field class="input-disabled" fxFlex="20%">
        <input matInput readonly [(ngModel)]="cabecalho.area" placeholder="ÁREA">
      </mat-form-field>
      <mat-form-field class="input-disabled" fxFlex="60%">
        <input matInput readonly [(ngModel)]="pedidos" placeholder="PEDIDOS">
      </mat-form-field>
    </div>
    <br />
  </div>
  <div class="table custom-Border" *ngIf="exibirResultadoHistorico">
    <div style="padding-left: 80%;">
      <mat-form-field style="width:100%">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
      </mat-form-field>
    </div>
    <div class="table-container">
      <h4>Histórico Protocolo</h4>
      <table mat-table [dataSource]="dataSource" style="width:100%;">
        <ng-container matColumnDef="dataStatus">
          <th mat-header-cell *matHeaderCellDef> Data </th>
          <td mat-cell *matCellDef="let row"> {{row.dataStatus | date: 'dd/MM/yyyy - HH:mm:ss' }} </td>
        </ng-container>
        <ng-container matColumnDef="acao">
          <th mat-header-cell *matHeaderCellDef> Ação </th>
          <td mat-cell *matCellDef="let row"> {{row.acao}} </td>
        </ng-container>
        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef> Descrição </th>
          <td mat-cell *matCellDef="let row"> {{row.descricao}} </td>
        </ng-container>
        <ng-container matColumnDef="usuario">
          <th mat-header-cell *matHeaderCellDef> Usuário </th>
          <td mat-cell *matCellDef="let row"> {{row.usuario}} </td>
        </ng-container>
        <ng-container matColumnDef="area">
          <th mat-header-cell *matHeaderCellDef> Área responsável </th>
          <td mat-cell *matCellDef="let row"> {{row.area}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator #historicoPaginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>

  </div>
</div>